import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when the board templates modal is opened',
  name: 'board_templates_opened',
  params: [
    {
      description: 'The type of template interaction',
      name: 'type',
      required: true,
      type: 'enum',
      values: ['board'],
    },
  ],
};

export default META;
